import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useUtils } from "@/app/hooks/useUtils";
import { ILabReportListState, setLabReportListFilter } from "@/app_redux/reducers/slices/auth/lab_report_slice";
import { useLabReportFilterListAPI } from "@/app/hooks/api_hooks/LabReport/useLabReportFilterListAPI";
import { useDispatch } from "react-redux";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useLabReportStatsListAPI } from "@/app/hooks/api_hooks/LabReport/useLabReportStatsListAPI";
import { INCOMING_STATUS_ID_MAP, STATUS_ID_MAP } from "../constants";

interface Props {
  selectedStatus: string;
  setSelectedStatus: React.Dispatch<React.SetStateAction<string>>;
}

const LabReportStats = ({ selectedStatus, setSelectedStatus }: Props) => {
  const { statsList } = useRouteInfo("LAB_REPORT")?.routeState?.state as ILabReportListState;
  const appliedFilters = useAppSelector((state) => state.routes.auth.LAB_REPORT?.state?.labReportListFilter);
  const { statusFormatLebel } = useUtils();
  const dispatch = useDispatch();
  const location = useLocation();

  const { execute: fetchLabReports } = useLabReportFilterListAPI();
  const fetchStatsList = useLabReportStatsListAPI();

  const today = new Date();
  const twoWeeksFromNow = new Date();
  twoWeeksFromNow.setDate(today.getDate() - 30);
  const [selectionDate, setSelectionDate] = useState({ startDate: twoWeeksFromNow, endDate: today, key: "selectionDate" });
  const startDate = new Date(selectionDate.startDate);
  const endDate = new Date(selectionDate.endDate);
  const startYear = startDate.getFullYear();
  const startMonth = (startDate.getMonth() + 1).toString().padStart(2, "0");
  const startDay = startDate.getDate().toString().padStart(2, "0");
  const endYear = endDate.getFullYear();
  const endMonth = (endDate.getMonth() + 1).toString().padStart(2, "0");
  const endDay = endDate.getDate().toString().padStart(2, "0");
  const formattedStartDate = `${startYear}-${startMonth}-${startDay}`;
  const formattedEndDate = `${endYear}-${endMonth}-${endDay}`;

  const LabType = (tab: string) => {
    if (tab === "incoming") return 2;
    if (tab === "external") return 1;
    if (tab === "internal") return 3;
  };

  useEffect(() => {
    if (appliedFilters?.clinic_ids?.length) {
      fetchStatsList(appliedFilters);
    }
  }, [appliedFilters?.clinic_ids]);
  const handleStatusClick = (statusKey: string) => {
    const labTestType = location?.pathname?.split("/").pop();
    const statusValue =
      labTestType === "incoming"
        ? INCOMING_STATUS_ID_MAP[statusKey]
        : STATUS_ID_MAP[statusKey];
    setSelectedStatus(statusKey);

    const type = LabType(labTestType);

    const filters: any = {
      ...appliedFilters,
      clinic_ids: appliedFilters?.clinic_ids || [],
      start_date: appliedFilters?.start_date,
      end_date: appliedFilters?.end_date,
      type: type,
      status_ids: Array.isArray(statusValue)
        ? statusValue
        : [statusValue],
    };
    fetchLabReports(filters);
    dispatch(setLabReportListFilter(filters));
  };

  return (
    <>
      <div className="overflow-x-auto overflow-y-hidden bg-white">
        <div className="flex gap-3 sm:gap-6 w-full">

          {statsList &&
            Object.keys(statsList).map((key) => (
              <div
                key={key}
                onClick={() => handleStatusClick(key)}
                className={`w-[184px] py-1.5 px-3 flex flex-col rounded-lg cursor-pointer border ${selectedStatus === key ? "border-black" : "border-[#E2E2E2]"}`}
              >
                <h3 className="text-black text-sm font-semibold">
                  {statsList[key]}</h3>
                <p className="text-[#6C727F] text-xs font-medium capitalize mt-1">
                  {statusFormatLebel(key)}
                </p>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};
export default LabReportStats;
